module.exports = __webpack_public_path__ + "img/logo.fb08d7c5.png";